import { COMPONENTS } from "@tSurya/theme/design";

export default (COMPONENTS as any)?.pagination || {};
